/**
 * Read a lookup table with a runtime key the table is not guaranteed to cover.
 *
 * `noUncheckedIndexedAccess` is off in this app — `apps/web` and `apps/admin`
 * carry their own tsconfigs and do not extend `@postdaily/config`, which turns
 * it on for every package — so `TABLE[key]` types as `Value` even when the key
 * is absent. Every `TABLE[key] ?? fallback` written against a
 * raw index read is therefore unchecked on the left-hand side: TypeScript
 * believes the miss cannot happen, so it can neither warn that a fallback went
 * dead nor stop one from being dropped. Returning `Value | undefined` puts the
 * miss in the contract.
 *
 * Taking the open key here is what lets the tables themselves stay closed — a
 * `const … = { … } as const` (or `satisfies`) keeps its key evidence, so a
 * renamed or deleted entry is a compile error at every site that names one.
 */
export function lookupBy<Value>(
  table: Readonly<Record<string, Value>>,
  key: string,
): Value | undefined {
  return Object.hasOwn(table, key) ? table[key] : undefined;
}
